var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":!_vm.userData,"rounded":"sm"}},[_c('div',[(_vm.userData)?_c('user-edit-tab-account',{staticClass:"mt-2 pt-75",attrs:{"selfie":_vm.selfie,"user-data":_vm.userData},on:{"submitEdit":_vm.submitEdit}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }